import React, { useState } from 'react'
import Select from 'react-select'
import { CTooltip } from '@coreui/react'
import { Info } from 'lucide-react'

const DisplayQuestionViewOnly = ({ fetchedQuestions }) => {
  const [inputValues, setInputValues] = useState({})
  const [linkedQuestions, setLinkedQuestions] = useState({})

  const handleInputChange = (e, id) => {
    setInputValues((prev) => ({
      ...prev,
      [id]: e.target.value,
    }))
  }

  const handleSelectChange = (e, ques) => {
    setInputValues((prev) => ({
      ...prev,
      [ques.id]: e.label,
    }))

    if (e.linkedQuestion) {
      const linkedQuesArray = Array.isArray(e.linkedQuestion) ? e.linkedQuestion : [e.linkedQuestion]
      setLinkedQuestions((prev) => ({
        ...prev,
        [ques.id]: linkedQuesArray,
      }))
    } else {
      setLinkedQuestions((prev) => {
        const { [ques.id]: _, ...rest } = prev
        return rest
      })
    }
  }

  const renderQuestions = (questions, isNested = false) => {
    return questions.map((ques, idx) => {
      return (
        <div
          key={idx}
          className={`custom-form-builder-theme__question-card d-flex flex-column gap-3 p-3 mb-3 shadow-sm ${isNested ? 'custom-form-builder-theme__question-card--nested' : ''} ${ques?.type === 'input' ? 'visible' : ques?.type === 'dropdown' ? 'visible' : ques?.type === 'Header' || ques?.type === 'subHeader' ? 'visible' : 'invisible d-none'}`}
          style={{
            cursor: 'default',
            height: 'auto',
            borderRadius: isNested ? '5px' : '20px',
            maxWidth: '100%',
            paddingLeft: isNested ? '16px' : '0',
            margin: isNested ? '12px' : '0',
          }}
        >
          {ques?.type === 'Header' ? (
            //  HEADER
            <div className="d-flex flex-column gap-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <label className={`${isNested ? 'fw-medium' : 'fw-bold'}`} style={{ maxWidth: '400px' }}>
                    {ques?.label}
                  </label>
                </div>
              </div>
            </div>
          ) : ques?.type === 'subHeader' ? (
            // Sub Header
            <div className="d-flex flex-column gap-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <label className={`${isNested ? 'fw-medium' : 'fw-bold'}`} style={{ maxWidth: '400px' }}>
                    {ques?.label}
                  </label>
                </div>
              </div>
            </div>
          ) : ques?.type === 'input' ? (
            // INPUT
            <div className="d-flex flex-column gap-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <label className={`${isNested ? 'fw-medium' : 'fw-bold'}`} style={{ maxWidth: '400px' }}>
                    {ques?.label}
                  </label>
                  {Boolean(ques?.toolTipValue?.trim?.()) && (
                    <CTooltip content={ques.toolTipValue}>
                      <Info size={16} />
                    </CTooltip>
                  )}
                </div>
              </div>

              {ques?.isTextArea ? (
                <textarea value={inputValues[ques?.id] || ''} onChange={(e) => handleInputChange(e, ques?.id)} placeholder="Enter your answer here..." className="form-control" rows="4" />
              ) : (
                <input type="text" onChange={(e) => handleInputChange(e, ques?.id)} value={inputValues[ques?.id] || ''} placeholder="Enter your answer here..." className="form-control" />
              )}
            </div>
          ) : (
            // DROPDOWN
            <div className="d-flex flex-column gap-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <label className={`${isNested ? 'fw-medium' : 'fw-bold'}`} style={{ maxWidth: '400px' }}>
                    {ques?.label}
                  </label>
                  {Boolean(ques?.toolTipValue?.trim?.()) && (
                    <CTooltip content={ques.toolTipValue}>
                      <Info size={16} />  
                    </CTooltip>
                  )}
                </div>
              </div>

              <Select
                isMulti={ques?.isMultiple}
                options={ques?.options}
                onChange={(e) => handleSelectChange(e, ques)}
                className="basic-multi-select"
                classNamePrefix="select"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
              />

              {linkedQuestions[ques.id] && renderQuestions(linkedQuestions[ques.id], true)}
            </div>
          )}
        </div>
      )
    })
  }

  const list = Array.isArray(fetchedQuestions) ? fetchedQuestions : fetchedQuestions?.questionData || []
  return <div>{list.length > 0 && renderQuestions(list)}</div>
}

export default DisplayQuestionViewOnly
